import Skeleton from "react-loading-skeleton";
import styles from "./index.module.css";

const FilterPanelSkeleton = () => {
  return (
    <div
      className={styles.filterPanel}
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "1.5rem",
      }}
    >
      <Skeleton height={28} width="60%" />

      {Array.from({ length: 4 }).map((_, sectionIndex) => (
        <div
          key={sectionIndex}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "0.8rem",
          }}
        >
          <Skeleton height={20} width="50%" />

          {Array.from({ length: 4 }).map((_, btnIndex) => (
            <Skeleton
              key={btnIndex}
              height={32}
              width="100%"
              style={{ borderRadius: 8 }}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default FilterPanelSkeleton;
